var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_52",
    "data-name": "Komponente 10 \\u2013 52",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.999,
    height: 58,
    viewBox: "0 0 57.999 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dumbell",
    transform: "translate(-0.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46686",
    "data-name": "Pfad 46686",
    d: "M278.975,72.767a1.132,1.132,0,1,0,1.6,0A1.133,1.133,0,0,0,278.975,72.767Zm0,0",
    transform: "translate(-246.635 -64.229)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46687",
    "data-name": "Pfad 46687",
    d: "M73.267,278.485a1.132,1.132,0,1,0,1.6,0A1.131,1.131,0,0,0,73.267,278.485Zm0,0",
    transform: "translate(-64.23 -246.645)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46688",
    "data-name": "Pfad 46688",
    d: "M57.17,15.746l-3.2-3.2,2.4-2.4a3.4,3.4,0,0,0,0-4.807l-3.2-3.2a3.4,3.4,0,0,0-4.806,0l-2.4,2.4-3.2-3.2a4.532,4.532,0,0,0-7.589,2.056,5.664,5.664,0,0,0-7.63,8.356l5.607,5.607L17.847,32.642l-5.607-5.607a5.663,5.663,0,0,0-8.355,7.63,4.533,4.533,0,0,0-2.058,7.588l3.2,3.2-2.4,2.4a3.4,3.4,0,0,0,0,4.806l3.2,3.2a3.4,3.4,0,0,0,4.806,0l2.4-2.4,3.2,3.2a4.533,4.533,0,0,0,7.589-2.057,5.663,5.663,0,0,0,7.63-8.356l-5.607-5.607L41.15,25.358l5.607,5.606a5.663,5.663,0,0,0,8.355-7.629,4.533,4.533,0,0,0,2.057-7.589ZM49.961,3.731a1.134,1.134,0,0,1,1.6,0l3.2,3.2a1.134,1.134,0,0,1,0,1.6l-2.4,2.4L47.559,6.133ZM9.037,54.268a1.134,1.134,0,0,1-1.6,0l-3.2-3.2a1.135,1.135,0,0,1,0-1.6l2.4-2.4,4.806,4.806Zm12.014.8a2.262,2.262,0,0,1-3.2,0c-23.8-23.8,2.853,2.853-14.418-14.418a2.265,2.265,0,1,1,3.2-3.2L21.051,51.866h0A2.263,2.263,0,0,1,21.051,55.069Zm8.811-2.4a3.394,3.394,0,0,1-4.805,0L8.236,35.846l-2.4-2.4a3.4,3.4,0,0,1,4.806-4.805L29.862,47.861a3.394,3.394,0,0,1,0,4.806ZM24.256,39.049,19.45,34.243,34.742,18.95l4.806,4.806Zm28.909-9.687a3.4,3.4,0,0,1-4.806,0C19.418.423,50.749,31.752,29.136,10.139a3.4,3.4,0,0,1,4.805-4.806L53.165,24.557a3.4,3.4,0,0,1,0,4.805Zm2.4-8.81a2.262,2.262,0,0,1-3.2,0h0L37.947,6.133a2.265,2.265,0,0,1,3.2-3.2L55.568,17.349A2.262,2.262,0,0,1,55.567,20.552Zm0,0",
    transform: "translate(0 0)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46689",
    "data-name": "Pfad 46689",
    d: "M114.362,321.186a1.133,1.133,0,1,0,1.6-1.6L103.148,306.77a1.133,1.133,0,1,0-1.6,1.6Zm0,0",
    transform: "translate(-89.306 -271.724)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46690",
    "data-name": "Pfad 46690",
    d: "M308.863,101.047a1.133,1.133,0,0,0-1.6,1.6l12.815,12.816a1.133,1.133,0,1,0,1.6-1.6Zm0,0",
    transform: "translate(-271.717 -89.307)",
    fill: "#a5b5af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.ba600d05c75b45d6abaa2479112225c4.svg";
export { ForwardRef as ReactComponent };